export default __webpack_public_path__ + "static/media/raasi-logo.27af415c.png";